import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import { Outlet } from "react-router-dom";
import BackMethods from "../back_component/BackMethods";

const DashboardLayout = () => {
  const [isOpen, setIsOpen] = useState(true);
  const { token, logout } = BackMethods();

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div dir="rtl ">
      <Navbar toggleSidebar={toggleSidebar} />
      <Sidebar isOpen={isOpen} />
      <main
        className="py-5"
        style={{

          marginRight: isOpen ? "240px" : "0",
          transition: "margin-right 0.3s ease-in-out",
        }}
      >
        <Outlet />
      </main>
    </div>
  );
};

export default DashboardLayout;
